import { InjectionToken, Injector } from '@angular/core';

export interface IDynamicInjectorProvider {
    getDynamicInjector(): Injector;
}

export const DYNAMIC_INJECTOR_PROVIDER_TOKEN = new InjectionToken<IDynamicInjectorProvider>('DYNAMIC_INJECTOR_PROVIDER_TOKEN');
